import React, { useEffect, useState } from 'react'

import * as S from './styles'
import { Card, Typography } from '@material-ui/core'
import tanqueAzul from '~/assets/images/SgtaTanques/tanqueAzul.jpg'
import tanqueVermelho from '~/assets/images/SgtaTanques/tanqueVermelho.jpg'
import tanqueVerde from '~/assets/images/SgtaTanques/tanqueVerde.jpg'
import tanqueAmarelo from '~/assets/images/SgtaTanques/tanqueAmarelo.jpg'

import { makeStyles } from '@material-ui/core/styles';
import { isEmpty, trim } from 'lodash'


const useStyles = makeStyles({
    root: {
        width: '100%',
        height: 200,
        margin: 5,
        backgroundColor: '#e1e1e1'
    }
})

export default function CardGrid({ dataBico }) {

    const classes = useStyles();
    const [tankImage, setTankImage] = useState('')
    const [bicoClass, setBicoClass] = useState('')

    useEffect(() => {
        if (dataBico.terminal_estado == "Desconectado") {
            setTankImage(tanqueVermelho)
            setBicoClass('vermelho')
        } else {
            switch (dataBico.status) {
                case "0":
                    setTankImage(tanqueAzul)
                    setBicoClass('azul')
                    break;
                case "8":
                    setTankImage(tanqueAmarelo)
                    setBicoClass('amarelo')
                    break;
                default:
                    setTankImage(tanqueVerde)
                    setBicoClass('verde')

            }
        }
    }, [dataBico])


    //       case "0": this.setStyle("backgroundImage", Application.application.imgBicoAzul); break;                
    //       case "8": this.setStyle("backgroundImage", Application.application.imgBicoAmarelo); break;                                
    //       default : this.setStyle("backgroundImage", Application.application.imgBicoVerde); break



    return (
        <S.CardContainer>
            <Card className={classes.root}
                style={{
                    backgroundImage: `url(${tankImage})`,
                    padding: 10,
                    backgroundRepeat: 'no-repeat',
                    overflow: 'hidden',
                    backgroundPosition: '10px bottom'
                }} >
                <S.CardContent>
                    <Typography gutterBottom variant="h6"  style={{ textAlign: 'center' }}>
                        Bico {dataBico.codigoBico}
                    </Typography>

                    <S.DataGrid>
                        <span className={`data-title ${bicoClass}`}>Frota</span>
                        <span className="data-bico">{!isEmpty(trim(dataBico.codigoFrota)) ? dataBico.codigoFrota : '-'}</span>

                        <span className={`data-title ${bicoClass}`}>Encerrante</span>
                        <span className="data-bico">{!isEmpty(trim(dataBico.encerranteBico)) ? dataBico.encerranteBico : 0.00}</span>

                        <span className={`data-title ${bicoClass}`}>Litros</span>
                        <span className="data-bico">{!isEmpty(trim(dataBico.litros)) ? dataBico.litros : 0.00}</span>

                        <span className={`data-title ${bicoClass}`}>Última At.</span>
                        <span className="data-bico">{dataBico.UltimaConexao}</span>
                    </S.DataGrid>
                </S.CardContent>

            </Card>
        </S.CardContainer>

    )
}